import { RRule } from 'rrule';

export const isNumber = (n): boolean => !isNaN(parseFloat(n)) && !isNaN(n - 0);

export const getByWeekRule = (days: string[]): any[] => {
  const byWeek: any[] = [];
  days.forEach(day => {
    switch (+day) {
      case 1:
        byWeek.push(RRule.MO);
        break;
      case 2:
        byWeek.push(RRule.TU);
        break;
      case 3:
        byWeek.push(RRule.WE);
        break;
      case 4:
        byWeek.push(RRule.TH);
        break;
      case 5:
        byWeek.push(RRule.FR);
        break;
    }
  });
  return byWeek;
};
